import React from 'react';
import type { ValueType } from 'react-select';
import { breakpoints } from '@99designs/emu/settings';
import { SearchableSelect } from '../../components/Form/SearchableSelect';
import { industries } from '../../utils/industries';
import { STEP_INDUSTRY } from '../constants';
import type { Option } from '../../components/Form/SearchableSelect';
import type { StepComponentProps } from '../../components/Onboarder/Config';
import type { SelectedValues } from '../config';

export type IndustryValue = string;

const getPlaceholderText = () => {
    if (window.innerWidth < breakpoints['medium'][0]) {
        return __('Select industry');
    }
    return __('Search for or select an industry');
};

export function IndustryStepInputs({ data, onChange }: StepComponentProps<SelectedValues>) {
    const value = industries().find((industry) => industry.value === data[STEP_INDUSTRY]);

    const handleChange = (selectedOption: ValueType<Option, boolean>) => {
        const selectedOptionValue = selectedOption ? (selectedOption as Option).value : undefined;

        onChange({
            ...data,
            [STEP_INDUSTRY]: selectedOptionValue,
        });
    };

    return (
        <SearchableSelect
            onChange={handleChange}
            options={industries()}
            value={value}
            label="industry-select"
            placeholderText={getPlaceholderText()}
            name={STEP_INDUSTRY}
        />
    );
}
